import { React } from "react";

import './Despre.scss';


const Despre = ( props ) => {

    return (
        <div className="despreNoi container">
            <div className='body-area' dangerouslySetInnerHTML={{__html: props.text}} />
        </div>
    );
  };
  
  export default Despre;